"use strict";
/**
 * StandOut WordPress Theme
 * Template-specific functionality initialization
 * Uses body classes to determine current template
 *
 * @package StandOut
 * @since 2.0.0
 */
// Button animations (GSAP entrance — loads on all pages)
import("./button-animations").catch((error) => {
    console.error("Failed to load button animations module:", error);
});
// Default page template
const page = document.getElementsByClassName("page-template-default");
if (page.length > 0) {
    import("./page").catch((error) => {
        console.error("Failed to load page template module:", error);
    });
}
